import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="px-3 md:px-4 pb-3 md:pb-4 pt-6 md:pt-10 bg-background-50 relative z-10">
      <div className="rounded-2xl bg-primary-900 text-background-100 overflow-hidden">
        <div className="px-5 sm:px-6 md:px-12 pt-10 sm:pt-12 md:pt-16 pb-8 md:pb-12 grid grid-cols-1 md:grid-cols-12 gap-8 sm:gap-10 md:gap-8">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5 mb-6">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-flashlight-fill text-xl"></i>
              </span>
              <div className="flex flex-col leading-tight">
                <span className="text-lg font-heading font-semibold text-background-50">Watts &amp; Wire</span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-background-300">Islington Electrician</span>
              </div>
            </div>
            <p className="text-sm text-background-200 leading-relaxed max-w-xs">
              Independent local electrician for homes, flats, landlords and small businesses across Islington and nearby North London.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <span className="relative w-2.5 h-2.5 rounded-full text-emerald-400 pulse-dot bg-emerald-400"></span>
              <span className="text-sm text-background-100">Available this week</span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-background-300 mb-4">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="hover:text-accent-400 transition-colors cursor-pointer" to="/services">Services</Link></li>
              <li><Link className="hover:text-accent-400 transition-colors cursor-pointer" to="/pricing">Pricing</Link></li>
              <li><Link className="hover:text-accent-400 transition-colors cursor-pointer" to="/about">About</Link></li>
              <li><Link className="hover:text-accent-400 transition-colors cursor-pointer" to="/area">Service Area</Link></li>
              <li><Link className="hover:text-accent-400 transition-colors cursor-pointer" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-background-300 mb-4">Get in touch</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="tel:+447700900123" className="flex items-center gap-2 hover:text-accent-400 transition-colors cursor-pointer">
                  <i className="ri-phone-fill"></i> 07700 900123
                </a>
              </li>
              <li>
                <a href="https://wa.me/447700900123" className="flex items-center gap-2 hover:text-accent-400 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line"></i> WhatsApp
                </a>
              </li>
              <li>
                <a href="mailto:hello@wattsandwire.co.uk" className="flex items-center gap-2 hover:text-accent-400 transition-colors cursor-pointer">
                  <i className="ri-mail-line"></i> hello@wattsandwire.co.uk
                </a>
              </li>
              <li className="flex items-center gap-2 text-background-200">
                <i className="ri-map-pin-line"></i> Upper Street, Islington N1
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-background-300 mb-4">Book a visit</h4>
            <p className="text-sm text-background-200 mb-4">Prefer to choose a time online? It takes about a minute.</p>
            <Link
              to="/book"
              className="group inline-flex items-center gap-2 px-4 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Book Appointment
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
            </Link>
            <div className="mt-6 flex items-center gap-3 text-xs text-background-300">
              <span className="inline-flex items-center gap-1"><i className="ri-shield-check-line"></i> Fully qualified</span>
              <span className="inline-flex items-center gap-1"><i className="ri-check-double-line"></i> Insured</span>
            </div>
          </div>
        </div>

        <div className="relative border-t border-background-50/10">
          <div className="hidden md:block absolute inset-x-0 -bottom-2 select-none pointer-events-none overflow-hidden">
            <div className="text-[16vw] leading-none font-heading font-bold text-background-50/[0.06] whitespace-nowrap tracking-tight">
              WATTS &amp; WIRE
            </div>
          </div>
          <div className="relative px-5 sm:px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300 text-center sm:text-left">
            <p>© {new Date().getFullYear()} Watts &amp; Wire · Local Islington Electrician</p>
            <div className="flex items-center gap-5">
              <a href="#" className="hover:text-accent-400 cursor-pointer">Privacy</a>
              <a href="#" className="hover:text-accent-400 cursor-pointer">Terms</a>
              <a href="#" className="hover:text-accent-400 cursor-pointer">Insurance</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}